// Copyright (c) 2022 by Move Closer

import { ComputedRef, Data } from '@vue/composition-api'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type ListElement = string | number | Data

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum ListOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum ListStyle {
  Boxed = 'boxed',
  NoPointer = 'none',
  Ordered = 'ordered',
  UnOrdered = 'unordered'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ListProps {
  elementClass?: string | string[] | Data
  elements: ListElement[]
  listStyle: ListStyle
  orientation: ListOrientation
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface UseListProvides {
  orientationClass: ComputedRef<string>
  pointerClass: ComputedRef<string>
  tag: ComputedRef<string>
}
